import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateSearchNoResultsColored,
  EmptystateModulesColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";
import LinkButton from "ds/components/Button/LinkButton";
import useCanCreateModule from "shared/Module/access/useCanCreateModule";

type ModulesEmptyProps = {
  hasNoSearchResult?: boolean;
};

const ModulesEmpty = ({ hasNoSearchResult }: ModulesEmptyProps) => {
  const canCreateModule = useCanCreateModule();

  return (
    <>
      {hasNoSearchResult && (
        <EmptyState
          title="No results"
          icon={EmptystateSearchNoResultsColored}
          caption="Don’t give up! Check the spelling or try something less specific."
          announce
        />
      )}

      {!hasNoSearchResult && canCreateModule && (
        <EmptyState title="You don’t have any modules yet" icon={EmptystateModulesColored}>
          <Box gap="medium">
            <DocumentationButton
              to={getDocsUrl("/vendors/terraform/module-registry.html")}
              label="Documentation"
            />
            <LinkButton variant="primary" to="/new/module">
              Create module
            </LinkButton>
          </Box>
        </EmptyState>
      )}
      {!hasNoSearchResult && !canCreateModule && (
        <EmptyState
          title="Spacelift is no fun without modules and you don't have access to any yet"
          icon={EmptystateModulesColored}
          caption="Please reach out to one of your friendly account admins to grant you access, or create a
              new module for you to play with."
        />
      )}
    </>
  );
};

export default ModulesEmpty;
